import { initI18n } from '@pperform/pp-react-components/PpLanguages';
import ENDPOINTS from 'constants/endpoints.constants';
import { DEFAULT_TRANSLATION } from '@pperform/pp-constants/translations';

export const ptpLanguageI18n = initI18n(
  [
    `${ENDPOINTS.PP_SHARED_ASSETS}/tracking-experience-translations/{{language}}.json`,
    `${ENDPOINTS.PP_SHARED_ASSETS}/pp-translations/common-translations/event-types/{{language}}.json`,
  ],
  DEFAULT_TRANSLATION.ppLanguageCode,
);

export default ptpLanguageI18n;
